import axios from 'axios'
import download from 'downloadjs'
import _ from 'lodash'

// Actions
import { signOut } from '../Deauth/actions'

// Contants
import { getDates, extractValue } from '../FilterPanel/constants'

// Axios
import { serverAPI } from '../../index'

// Action types
export const RESET_DASHBOARD_DATA = 'reset_dashboard_data'
export const CHANGE_DASHBOARD_DATA = 'change_dashboard_data'
export const CHANGE_DASHBOARD_EXPORTING = 'change_dashboard_exporting'
export const CHANGE_DASHBOARD_DIFFERENCE_MEDIAN = 'change_dashboard_difference_median'
export const CHANGE_DASHBOARD_PERCENTAGE_MEDIAN = 'change_dashboard_percentage_median'

export function resetDashboardData() {
  return {
    type: RESET_DASHBOARD_DATA
  }
}

export function changeDashboardData(data, block) {
  return {
    type: CHANGE_DASHBOARD_DATA,
    payload: { data, block }
  }
}

export function changeDashboardExporting(exporting) {
  return {
    type: CHANGE_DASHBOARD_EXPORTING,
    payload: exporting,
  }
}

export function changeDashboardDifferenceMedian(differenceMedian) {
  return {
    type: CHANGE_DASHBOARD_DIFFERENCE_MEDIAN,
    payload: differenceMedian,
  }
}

export function changeDashboardPercentageMedian(percentageMedian) {
  return {
    type: CHANGE_DASHBOARD_PERCENTAGE_MEDIAN,
    payload: percentageMedian,
  }
}

export function exportReport(period, companies, lawFirms, regions, classifiers) {
  const filters = {
    companies: extractValue(companies.selected),
    law_firms: extractValue(lawFirms.selected),
    regions: extractValue(regions.selected),
    classifiers: extractValue(classifiers.selected)
  }
  let date = getDates('last30days')

  if (!_.isEmpty(period.selected)) {
    date = getDates(period.selected[0].value)
  }

  return dispatch => {
    dispatch(changeDashboardExporting(true))

    serverAPI.post(`/statistics/report/${date}`, { filters })
      .then(response => {
        dispatch(changeDashboardExporting(false))

        const byteCharacters = atob(response.data);
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers)
        const file = new Blob([byteArray], { type: 'application/pdf' })

        download(file, 'relatório.pdf', 'application/pdf')
      })
      .catch(_ => {
        dispatch(changeDashboardExporting(false))
      })
  }
}
